import { CurrenciesBuilder, CurrencyOutput } from '../currencies.types';

export const getAllCurrencies = (builder: CurrenciesBuilder) =>
  builder.query<CurrencyOutput[], void>({
    query: () => ({ url: '/currencies', method: 'GET' }),
  });
